exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.allClusterMetadata .v-text-field__details {\n    display: none !important;\n}\n.allClusterMetadata .v-input__slot {\n    margin-bottom: auto;\n}\n\n", ""]);
